import { gql } from '@apollo/client'

export const SalaryConfig = {
    salaryConfigs: 'salaryConfigs',
    salaryConfig : "salaryConfig"
}

export const GET_SALARY_CONFIGS = gql`
query  getSalaryConfigs(
    $filter: String
    $page: Int
    $pageSize: Int
    $search: String
    $sort: String
) {
    ${SalaryConfig.salaryConfigs}(
        filter: $filter
        page: $page
        pageSize: $pageSize
        search: $search
        sort: $sort
    ) {
        items {
            externalReferenceCode
            id
            name
            create
            creatorDate
            applyDepartmentName
            applyPositionName
            employeeFollows {
                id
                name
                employeeId
            }
            employeeManages {
                id
                name
                employeeId
            }
            salaryType
        }
        page
        pageSize
        totalCount
    }
}`

export const GET_SALARY_CONFIG_ID = gql`

query getSalaryConfig($id : Long){
    ${SalaryConfig.salaryConfig}(id: $id) {
        id
        approvalId
        externalReferenceCode
        name
        keyword
        salaryType
        report
        autoGenerated
        applyDepartmentIds
        applyDePartments{
            departmentId
            name
            id
        }
        applyPositionIds
        applyPositions{
            name
            jobPositionId
            id
        }
        employeeManageIds
        employeeManages{
            code
            employeeId
            id
            name
        }
        employeeFollowIds
        employeeFollows{
            
            employeeId
            id
            name
        }
        salaryColumns{
            valueSynthetic
            valueColumn
            typeValue
            titleColumn
            rowValue
            paycheck
            paycheck
            keyColumn
            id
            formatOption
            describe
            configId
            columnName
            calculation
            newKeyColumn
        }
        create
        applyDepartmentName
        applyPositionName
        employeeManageName
        employeeFollowName
        creatorDate 
    }
}
`
